import {ModalContext} from 'app/app';
import axios from 'axios';
import {IconedButton} from 'components/IconedButton';
import {Pagination} from 'components/Pagination';
import {
  Animate,
  Grid,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import {useContext, useEffect, useState} from 'react';
import styles from './styles.module.scss';

export function Accounts() {
  const {setModal} = useContext(ModalContext);

  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');

  const context = useContext(ViewContext);

  const format = new DateUtils();
  const agency = (agencyId) => {
    if (agencyId) {
      const agencyString = 'A000000';
      const count = agencyId.split(' ')[0].length;

      return (
        agencyString.substring(0, agencyString.length - count) +
        agencyId
      );
    }
  };

  async function runAPI(page, search) {
    setLoading(true);

    await axios
      .get(`/api/account/list/search?page=${page}&search=${search}`)
      .then(async (res) => {
        setLoading(false);
        setPayload(res.data.data);

        var tempData = [];

        const timezone = await format.getTimezone();

        res.data.data.data.map((value, index) => {
          const status =
            value.status === 'total_disabled'
              ? 'Disabled'
              : value.active
                ? 'Active'
                : 'Inactive';

          tempData.push({
            id: value.id,
            name: value.name,
            label: agency(JSON.stringify(value.sequence)),
            'Created At': format.timestamp(value.createdAt, timezone),
            'Updated At':
              value.updatedAt === value.createdAt
                ? ''
                : format.timestamp(value.updatedAt, timezone),
            status: status,
            canImpersonate: status !== 'Disabled',
          });
        });


        setData(tempData);
      })
      .catch((err) => {
        setLoading(false);

        console.error(err);

        context.notification.show(
          'Failed to load table data',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  useEffect(() => {
    runAPI(page, searchQueryString);
  }, [searchQueryString]);

  return (
    <Animate type="pop">
      <div
        style={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{display: 'flex'}}>
          <div
            style={{
              width: '150px',
              backgroundColor: 'black',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: 'default',
            }}
          >
            Agencies
          </div>
          <div
            onClick={() => {
              window.location.href = '/admin/agencies/pending';
            }}
            style={{
              backgroundColor: '#EAEAEA',
              width: '150px',
              color: '#090E3480',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: 'pointer',
            }}
          >
            Pending
          </div>
        </div>
        <IconedButton
          size="140px"
          color="#d32425"
          textColor="white"
          icon="plus-circle"
          text="Add agency"
          marginRight
          action={() => {
            setModal({
              name: 'account_modal',
              action: () => runAPI(page, searchQueryString),
            });
          }}
        />
      </div>
      <Grid cols="1">
        <div className={styles.wrapper} style={{marginTop: 0}}>
          <div style={{marginBottom: 10}}>
            <Search
              callback={(query) => {
                setSearchQueryString(query);
              }}
            />
          </div>
          {window.location.host === 'localhost:5002' ? (
            <iframe
              id="receiver"
              src={`http://localhost:3000`}
              width="500"
              height="200"
              style={{display: 'none'}}
            />
          ) : (
            <iframe
              id="receiver"
              src={`https://app.coverbadger.com`}
              width="500"
              height="200"
              style={{display: 'none'}}
            />
          )}
          <Table
            data={data}
            hide={['id', 'canImpersonate']}
            loading={loading}
            badge={{
              col: 'status',
              condition: [
                {value: 'Active', color: 'green'},
                {value: 'Inactive', color: 'red'},
                {value: 'Disabled', color: 'grey'},
              ],
            }}
            actions={{
              custom: (row) => [
                {
                  icon: 'search',
                  action: () => {
                    window.location.href = `/admin/agency/${row.id}`;
                  },
                  color: '#637381',
                  tooltip: 'View company details',
                },
                ...(row.status !== 'Disabled'
                  ? [
                    {
                      icon: 'log-out',
                      action: () => {
                        setModal({
                          name: 'confirmation',
                          data: {
                            title: `Impersonate agency's owner`,
                            description: `Do you want to impersonate this agency's owner?`,
                          },
                          action: async () => {
                            setModal({});

                            try {
                              const res = await axios.post('/api/impersonate', {
                                impersonatableId: row.id,
                                type: 'account',
                              });

                              const receiver = document.getElementById('receiver').contentWindow;

                              receiver.postMessage(
                                res.data,
                                window.location.host === 'localhost:5002'
                                  ? 'http://localhost:3000'
                                  : 'https://app.coverbadger.com'
                              );

                              window.open(
                                window.location.host === 'localhost:5002'
                                  ? 'http://localhost:3000/app/dashboard'
                                  : 'https://app.coverbadger.com/app/dashboard'
                              );
                            } catch (err) {
                              console.error(err);
                              setModal('');
                            }

                            setModal('');
                          },
                        });
                      },
                      color: '#637381',
                      tooltip: "Impersonate agency's owner",
                    },
                  ]
                  : []),
              ],
            }}
          />
          {payload && !loading && (
            <Pagination
              pagesCount={payload.pages_count}
              active={payload.page}
              onChange={async (newPage) => {
                setPage(newPage);
                runAPI(newPage, searchQueryString);
              }}
            />
          )}
        </div>
      </Grid>
    </Animate>
  );
}
